import React from 'react';
import UploadPictures from "../../common/upload/UploadPictures";
import {injectIntl} from "react-intl";

const MAX_IDENTITY_DOCUMENTS = 4;

class IdentityDocuments extends React.Component {

  handleBeforeUpload = (file, category) => {
    const {identityDocuments, identityDocuments: {fileList}} = this.props;
    fileList[category] = [...fileList[category], file];
    identityDocuments.fileList = fileList;
    identityDocuments[category] = [...fileList, file];
    this.updateData(identityDocuments);
    return false;
  };

  handleDocumentsChange = ({fileList}) => {
    const {identityDocuments} = this.props;
    identityDocuments.attachments = fileList;
    this.updateData(identityDocuments);
  };

  handleFileRemove = (file, category) => {
    const {identityDocuments} = this.props;
    if (file.originFileObj) {
      const fileList = identityDocuments.fileList;
      fileList[category] = fileList[category].filter(f => f.uid !== file.uid);
      this.updateData(identityDocuments);
      return;
    }
    identityDocuments.outdatedFiles = [...identityDocuments.outdatedFiles, file.uid];
    this.updateData(identityDocuments);
  };

  updateData = (identityDocuments) => {
    this.props.onChange(identityDocuments);
  };

  render() {
    const {intl: {formatMessage}, identityDocuments: {attachments = []} = {}} = this.props;

    return (
      <UploadPictures files={attachments}
                      beforeUpload={(file) => this.handleBeforeUpload(file, 'attachments')}
                      onChange={this.handleDocumentsChange}
                      onRemove={(e) => this.handleFileRemove(e, 'attachments')}
                      allowUpload={attachments.length < MAX_IDENTITY_DOCUMENTS}/>
    )
  }
}

export default injectIntl(IdentityDocuments);



// WEBPACK FOOTER //
// ./src/components/carpark/delivery/IdentityDocuments.js